// extracted by mini-css-extract-plugin
export default {"button":"CustomAppBar_button__+0Z5+","container":"CustomAppBar_container__+G1m0"};